// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__WKQgz","question":"Question_question__ASD2Q","description":"Question_description__2TZ2e"};